import { Dispatch } from 'react';
import { useQuery } from '@tanstack/react-query';
import * as ENDPOINTS from './endpoints';
import { GoalsActionTypes } from '../reducer/goals.reducer';
import { useCustomMutation } from '@devd-client/devd/components';

export const QUERY_KEYS = {
  goals: 'goals',
  workFlows: 'workFlows',
};

export const useGetWorkflows = (team: string, dispatch: Dispatch<any>) => {
  return useQuery(
    [QUERY_KEYS.workFlows, team],
    () => ENDPOINTS.getWorkflows(team),
    {
      onSuccess: (data) => {
        dispatch({
          type: GoalsActionTypes.GET_GOALS_LIST,
          payload: data ?? [],
        });
      },
    }
  );
};

export const usePostAutomation = () =>
  useCustomMutation([QUERY_KEYS.workFlows], ENDPOINTS.postAutomation);
